import React from "react";
import {
  Box,
  Grid,
  Card,
  Typography,
  Button,
  TextField,
  Switch,
  Divider,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import DashboardHeader from "../Dashboard/DashboardHeader";

export default function FoodCard() {
  const { type } = useParams();
  const navigate = useNavigate();
  const formattedType = type ? type.replace("-", " ").toUpperCase() : "CARD";

  return (
    <>
      <DashboardHeader />
      <Box sx={{ backgroundColor: "#f5f6f8", minHeight: "80vh", p: 4, px:10}}>
        <Box display={"flex"} justifyContent={"space-between"}>
          <Typography variant="h6" fontWeight="bold" mb={3}>
            {formattedType} 
          </Typography>
          <Button
          variant="outlined"
            sx={{ cursor: "pointer", mb: 2, color: "black" }}
            onClick={() => navigate("/dashboard/expensemanagement")}
          >
            ← BACK TO CARDS
          </Button>
        </Box>

        <Grid container spacing={4}>
          {/* LEFT SIDEBAR */}
          <Grid size={{ xs: 12, md: 3 }} item xs={12} md={3}>
            <Box>
              <Card sx={{ p: 2, mb: 2, background: "#16a34a", color: "white" }}>
                Transaction Statement
              </Card>

              <Card sx={{ p: 2, mb: 2 }}>Terms & Conditions</Card>
              <Card sx={{ p: 2, mb: 3 }}>FAQ</Card>

              <Card sx={{ p: 3 }}>
                <Typography fontWeight="bold" mb={2}>
                  QUICK ACTIONS
                </Typography>

                <Box display="flex" justifyContent="space-between" mb={2}>
                  <Typography>Freeze Card</Typography>
                  <Switch />
                </Box>

                <Box display="flex" justifyContent="space-between">
                  <Typography>Show CVV</Typography>
                  <Typography color="green" fontWeight="bold">
                    REVEAL
                  </Typography>
                </Box>
              </Card>
            </Box>
          </Grid>

          {/* CENTER CONTENT */}
          <Grid size={{ xs: 12, md: 6 }} item xs={12} md={6}>
            <Card sx={{ p: 3, mb: 3 }}>
              <Grid container spacing={2} alignItems="center">
                <Grid size={{ xs: 5 }} item xs={5}>
                  <Typography>From</Typography>
                  <TextField fullWidth placeholder="dd-mm-yyyy" />
                </Grid>

                <Grid size={{ xs: 5 }} item xs={5}>
                  <Typography>To</Typography>
                  <TextField fullWidth placeholder="dd-mm-yyyy" />
                </Grid>

                <Grid size={{ xs: 2 }} item xs={2} mt={2}>
                  <Button
                    fullWidth
                    variant="contained"
                    sx={{
                      height: "56px",
                      backgroundColor: "#16a34a",
                      color:"#ffffff"
                    }}
                  >
                    FILTER
                  </Button>
                </Grid>
              </Grid>
            </Card>

            {/* Transactions */}
            <Card sx={{ p: 2 }}>
              {[
                { name: "Zomato Order", amount: "-₹450.00" },
                { name: "Swiggy Munchies", amount: "-₹220.00" },
                { name: "Telecom Recharge", amount: "+₹1,000.00" },
                { name: "Starbucks Coffee", amount: "-₹350.00" },
              ].map((txn, i) => (
                <Box key={i} mb={1}>
                  <Box display="flex" justifyContent="space-between">
                    <Box>
                      <Typography fontWeight="bold">{txn.name}</Typography>
                      <Typography fontSize="12px" color="gray">
                        ID: 987654321 · MAR 05
                      </Typography>
                    </Box>

                    <Box textAlign="right">
                      <Typography
                        fontWeight="bold"
                        color={txn.amount.includes("+") ? "green" : "black"}
                      >
                        {txn.amount}
                      </Typography>
                      <Typography fontSize="12px" color="gray">
                        COMPLETED
                      </Typography>
                    </Box>
                  </Box>
                  <Divider sx={{ mt: 2 }} />
                </Box>
              ))}
            </Card>
          </Grid>

          {/* RIGHT SIDE CARD */}
          <Grid size={{ xs: 12, md: 3 }} item xs={12} md={3}>
            <Card
              sx={{
                p: 3,
                background: "linear-gradient(135deg,#16a34a,#059669)",
                color: "white",
                borderRadius: 4,
              }}
            >
              <Typography mb={2}>Card Balance</Typography>
              <Typography variant="h5">₹15000.00</Typography>

              <Box mt={2}>
                <Typography fontSize="14px">5088 XXXX XXXX XXXX</Typography>
                <Typography fontSize="12px">VALID THRU XX/XX</Typography>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
